import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export var ClassNames;

(function (ClassNames) {
  /**
   * Concatenate classnames into a single string
   */
  function concat() {
    var classes = [];

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    for (var _i = 0, _args = args; _i < _args.length; _i++) {
      var argument = _args[_i];

      if (!argument) {
        continue;
      }

      if (typeof argument === 'string') {
        // if string add to output
        classes.push(argument);
      } else if (Array.isArray(argument)) {
        // if array, spread into output
        classes = [].concat(_toConsumableArray(classes), [concat(argument)]);
      } else if (typeof argument === 'object') {
        for (var key in argument) {
          // if object,
          if (argument[key]) {
            classes.push(key);
          }
        }
      }
    }

    return classes.join(' ');
  }

  ClassNames.concat = concat;
})(ClassNames || (ClassNames = {}));